import React from 'react';
import {currentResource, labels} from '../../../util/utils';
import utilityfunctions from '../../../util/utilityfunctions';
import CommonAdminTable from '../Common/CommonAdminTable';
import useDetailsSelector from '../Common/Hooks/GetDetailsHook';

function EngagementsTable() {
	const engagementInfo = useDetailsSelector('engagementsDetails');
	const engagementsTableConfig = {
		columns: [
			{
				label: labels.nameLabel,
				sortable: true,
				propName: 'engagementDescription',
				width: '25%'
			},
			{
				label: labels.engagementId,
				sortable: true,
				propName: 'canvasEngagementId',
				width: '25%'
			},
			{
				label: labels.client,
				sortable: true,
				propName: 'clientName',
				width: '25%'
			},
			{
				label: labels.entityLabel,
				sortable: true,
				propName: 'connectedEntityName',
				width: '25%'
			}
		],
		tableClassName: 'tabs-proj-table engagements-table',
		items: engagementInfo,
		sortConfig: {
			sortBy: 'engagementDescription',
			sortIsAscending: true
		}
	};
	return (
		<section>
			<CommonAdminTable config={engagementsTableConfig} />
		</section>
	);
}

export default EngagementsTable;
